{
  "circle": {
    "title": "Говорящий кружок",
    "screen": "circle",
    "options": {
      "who": "char",
      "drive": "text",
      "fmt": "circle"
    }
  },
  "vcircle": {
    "title": "Кружок из видео",
    "screen": "circle",
    "options": {
      "who": "video",
      "words": "own",
      "fmt": "circle"
    }
  },
  "pcircle": {
    "title": "Фото говорит",
    "screen": "circle",
    "options": {
      "who": "photo",
      "drive": "text",
      "fmt": "circle"
    }
  },
  "acircle": {
    "title": "Кружок из аудио",
    "screen": "circle",
    "options": {
      "who": "audio",
      "fmt": "circle"
    }
  },
  "photo": {
    "title": "Фото в новом стиле",
    "screen": "photo",
    "options": {
      "screen": "photo",
      "mode": "ph",
      "sty": "top"
    }
  },
  "shoot": {
    "title": "Фотосессия из селфи",
    "screen": "shoot",
    "options": {
      "screen": "shoot",
      "shoot": "neuro"
    }
  },
  "ava": {
    "title": "Фото на аватарку",
    "screen": "photo",
    "options": {
      "screen": "photo",
      "preset": "avatar"
    }
  },
  "restore": {
    "title": "Восстановить фото",
    "screen": "photo",
    "options": {
      "screen": "photo",
      "preset": "restore"
    }
  },
  "color": {
    "title": "Раскрасить чёрно-белое",
    "screen": "photo",
    "options": {
      "screen": "photo",
      "preset": "color"
    }
  },
  "family": {
    "title": "Семейный портрет",
    "screen": "shoot",
    "options": {
      "screen": "shoot",
      "shoot": "family"
    }
  },
  "post": {
    "title": "Карусель для поста",
    "screen": "post",
    "options": {
      "screen": "post"
    }
  },
  "collage": {
    "title": "Коллаж из фото",
    "screen": "collage",
    "options": {
      "screen": "collage"
    }
  },
  "avatar": {
    "title": "Свой аватар",
    "screen": "avatar",
    "options": {
      "screen": "avatar"
    }
  },
  "anim": {
    "title": "Оживить фото",
    "screen": "video",
    "options": {
      "screen": "video",
      "mode": "ph",
      "sty": "none"
    }
  },
  "video": {
    "title": "Видео в новом стиле",
    "screen": "video",
    "options": {
      "screen": "video",
      "mode": "fl",
      "sty": "top"
    }
  },
  "vedit": {
    "title": "Изменить видео",
    "screen": "video",
    "options": {
      "screen": "video",
      "mode": "vd",
      "sty": "none"
    }
  },
  "parallax": {
    "title": "Объёмное фото",
    "screen": "video",
    "options": {
      "screen": "video",
      "preset": "parallax"
    }
  },
  "lip": {
    "title": "Видео говорит",
    "screen": "circle",
    "options": {
      "who": "video",
      "words": "new",
      "fmt": "src"
    }
  },
  "card": {
    "title": "Видеооткрытка",
    "screen": "circle",
    "options": {
      "who": "char",
      "drive": "text",
      "card": true,
      "fmt": "9:16"
    }
  },
  "dance": {
    "title": "Повтори движения",
    "screen": "dance",
    "options": {
      "screen": "dance",
      "preset": "dance"
    }
  },
  "swap": {
    "title": "Стать персонажем",
    "screen": "dance",
    "options": {
      "screen": "dance",
      "preset": "swap"
    }
  },
  "reels": {
    "title": "Рилс с вами",
    "screen": "reels",
    "options": {
      "screen": "reels",
      "preset": "people"
    }
  },
  "series": {
    "title": "Анимация из серии",
    "screen": "reels",
    "options": {
      "screen": "reels",
      "preset": "series"
    }
  },
  "tlapse": {
    "title": "Видео из поездки",
    "screen": "reels",
    "options": {
      "screen": "reels",
      "preset": "timelapse"
    }
  },
  "polar": {
    "title": "Полароид-рилс",
    "screen": "reels",
    "options": {
      "screen": "reels",
      "preset": "slides"
    }
  },
  "kino": {
    "title": "Фильм из фотографий",
    "screen": "reels",
    "options": {
      "screen": "reels",
      "preset": "family"
    }
  },
  "script": {
    "title": "Озвучка проектов",
    "screen": "script",
    "options": {
      "screen": "script"
    }
  },
  "voice": {
    "title": "Сменить голос в записи",
    "screen": "voice",
    "options": {
      "screen": "voice",
      "mode": "other",
      "out": "file"
    }
  },
  "vmsg": {
    "title": "Почистить запись",
    "screen": "voice",
    "options": {
      "screen": "voice",
      "mode": "keep",
      "out": "voice",
      "noise": true
    }
  },
  "cover": {
    "title": "Создать кавер",
    "screen": "cover",
    "options": {
      "screen": "cover"
    }
  },
  "stt": {
    "title": "Текст из аудио и видео",
    "screen": "text",
    "options": {
      "screen": "text",
      "tool": "stt"
    }
  },
  "seo": {
    "title": "Описание товара",
    "screen": "text",
    "options": {
      "screen": "text",
      "tool": "seo"
    }
  },
  "pnew": {
    "title": "Создать промпт",
    "screen": "text",
    "options": {
      "screen": "text",
      "tool": "pnew"
    }
  },
  "pfix": {
    "title": "Улучшить промпт",
    "screen": "text",
    "options": {
      "screen": "text",
      "tool": "pfix"
    }
  },
  "pmedia": {
    "title": "Промпт из фото или видео",
    "screen": "text",
    "options": {
      "screen": "text",
      "tool": "pphoto"
    }
  },
  "mcard": {
    "title": "Карточка для маркетплейса",
    "screen": "mcard",
    "options": {
      "screen": "mcard"
    }
  },
  "pshoot": {
    "title": "Фотосессия товара",
    "screen": "pshoot",
    "options": {
      "screen": "pshoot"
    }
  },
  "infog": {
    "title": "Слайды с преимуществами",
    "screen": "infog",
    "options": {
      "screen": "infog"
    }
  },
  "vcover": {
    "title": "Видео товара, 5 сек",
    "screen": "video",
    "options": {
      "screen": "video",
      "preset": "cover"
    }
  }
}
